import styled, { css } from 'styled-components';
import { PropTypes } from './spinner';

const flex = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div<PropTypes>`
  ${({ center }) => center && flex}
  .MuiCircularProgress-root {
    color: var(--green);
  }
`;
